"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertMessage = exports.AlertMessageDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cn_1 = require("../../utils/cn");
var cls = (0, cn_1.classNames)('alert-message');
var icon_1 = require("./icon");
var icons_1 = require("../icons");
var markdown_1 = require("./markdown");
var use_lang_1 = require("../../hooks/use-lang");
exports.AlertMessageDefaultProps = {};
// -------- Styles -------->\
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background: ", ";\n    color: #FFF;\n    padding: ", " ", " ", ";\n    font-size: ", ";\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid ", ";\n\n    ", "\n\n    * {\n      color: #FFF !important;\n      ", "\n    }\n\n    ", "\n  "], ["\n    background: ", ";\n    color: #FFF;\n    padding: ", " ", " ", ";\n    font-size: ", ";\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid ", ";\n\n    ", "\n\n    * {\n      color: #FFF !important;\n      ", "\n    }\n\n    ", "\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3, 2), theme_1.theme.FONT_SIZE(14), theme_1.theme.COLOR('line-sidebar'), function (_a) {
    var isProminent = _a.isProminent;
    return !isProminent && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n      color: ", ";\n      ", ";\n    "], ["\n      background: ", ";\n      color: ", ";\n      ", ";\n    "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'));
  }, function (_a) {
    var isProminent = _a.isProminent;
    return !isProminent && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        color: ", " !important;\n      "], ["\n        color: ", " !important;\n      "])), theme_1.theme.COLOR('primary'));
  }, function (props) {
    return !!props.onClick && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n      }\n    "])));
  })
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: ", "; \n  "], ["\n    margin-right: ", "; \n  "])), theme_1.theme.UNIT(2))
});
var MarkdownStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Markdown: (0, styled_components_1.default)(markdown_1.Markdown)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), MarkdownStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var AlertMessage = function (props) {
  var className = props.className,
    text = props.text,
    isProminent = props.isProminent,
    onClick = props.onClick;
  var t = (0, use_lang_1.useLang)();
  return react_1.default.createElement(My.Container, {
    isProminent: isProminent,
    onClick: onClick,
    className: className
  }, react_1.default.createElement(My.Icon, {
    color: "light",
    size: 32,
    className: cls.sub('icon')
  }, react_1.default.createElement(icons_1.Icons.ExclamationCircle, null)), react_1.default.createElement(My.Markdown, {
    text: text
  }));
};
exports.AlertMessage = AlertMessage;
exports.AlertMessage.cls = cls;
exports.AlertMessage.defaultProps = exports.AlertMessageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;